import type { ComponentProps, ReactNode } from 'react';
import { VegaButton, VegaFlex, VegaModal } from '@globalpayments/vega-react';
import styles from './index.module.css';

type VegaModalProps = ComponentProps<typeof VegaModal>;

interface DetailsModalProps {
  ariaDescribedBy?: string;
  ariaLabelledBy?: string;
  backdrop?: VegaModalProps['backdrop'];
  children: ReactNode;
  className?: string;
  contentGap?: ComponentProps<typeof VegaFlex>['gap'];
  footerActions?: ReactNode;
  modalTitle: string;
  onClose: () => void;
  open: boolean;
  width?: VegaModalProps['width'];
}

/** Provides a viewport-bounded details dialog with content scrolling and a persistent Close action. */
const DetailsModal = ({
  ariaDescribedBy,
  ariaLabelledBy,
  backdrop,
  children,
  className,
  contentGap = 'size-16',
  footerActions,
  modalTitle,
  onClose,
  open,
  width = { default: '90%', M: '70%' },
}: DetailsModalProps) => (
  <VegaModal
    aria-describedby={ariaDescribedBy}
    aria-labelledby={ariaLabelledBy}
    backdrop={backdrop}
    className={`${open ? styles.detailsModalOpen : ''} ${className ?? ''}`}
    contentMaxHeight={{ default: 'calc(100vh - 240px)', M: 'calc(100vh - 272px)' }}
    handleClose={() => {
      onClose();
      return true;
    }}
    isVerticallyCentered
    modalTitle={modalTitle}
    onVegaClose={onClose}
    open={open}
    padding="size-24"
    showCloseButton
    width={width}>
    <VegaFlex direction="col" gap={contentGap} slot="content">
      {children}
    </VegaFlex>
    <VegaFlex gap="size-12" justifyContent="end" slot="footer">
      <VegaButton label="Close" onVegaClick={onClose} variant="secondary" />
      {footerActions}
    </VegaFlex>
  </VegaModal>
);

export default DetailsModal;
